module.exports = __webpack_public_path__ + "img/kopsurat_moyudan.dcbad0eb.png";